<template>
  <div class="not-shipped-orders">
    <el-form 
      ref="forwardForm" 
      :model="form" 
      :rules="rules" 
      label-width="120px"
      class="shipping-form">
      
      <!-- 订单基本信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>订单基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="orderInfo.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单编号" prop="orderSn">
              <el-input v-model="orderInfo.orderSn" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家名称" prop="merchantName">
              <el-input v-model="orderInfo.merchantName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器信息" prop="deviceName">
              <el-input v-model="orderInfo.deviceName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="orderInfo.contact" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="phone">
              <el-input v-model="orderInfo.phone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="联系地址" prop="address">
              <el-input v-model="orderInfo.address" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="样品数量" prop="testCount">
              <el-input v-model="orderInfo.testCount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单金额" prop="orderAmount">
              <el-input v-model="orderInfo.orderAmount" disabled>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 转寄信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>转寄信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="转寄商家" prop="targetMerchant">
              <el-select 
                v-model="form.targetMerchant" 
                filterable 
                placeholder="请选择转寄商家"
                @change="handleMerchantChange">
                <el-option
                  v-for="item in merchantOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器信息" prop="deviceInfo">
              <el-select 
                v-model="form.deviceInfo" 
                placeholder="请选择仪器信息"
                :disabled="!form.targetMerchant"
                @change="handleDeviceChange">
                <el-option
                  v-for="item in deviceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="仪器型号" prop="deviceModel">
              <el-input v-model="form.deviceModel" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参考价格" prop="referencePrice">
              <el-input v-model="form.referencePrice" disabled>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="实际价格" prop="actualPrice">
              <el-input v-model="form.actualPrice">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="form.contact" placeholder="请输入联系人姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="样品数量" prop="sampleCount">
              <el-input v-model="form.sampleCount" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="转寄地址" prop="address">
              <el-input
                type="textarea"
                v-model="form.address"
                :rows="3"
                placeholder="请输入详细地址">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="快递公司" prop="expressCompany">
              <el-select v-model="form.expressCompany" placeholder="请选择快递公司">
                <el-option
                  v-for="item in logisticsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物流单号" prop="trackingNumber">
              <el-input v-model="form.trackingNumber" placeholder="请输入物流单号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="转寄说明" prop="reason">
              <el-input
                type="textarea"
                v-model="form.reason"
                :rows="3"
                disabled>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 操作按钮 -->
      <div class="form-actions">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确认转寄</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'ForwardShipForm',
  props: {
    orderId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      orderInfo: {
        projectName: '',
        orderSn: '',
        merchantName: '',
        contact: '',
        phone: '',
        address: '',
        testCount: 0,
        deviceName: '',
        orderAmount: ''
      },
      merchantOptions: [], // 商家选项列表
      deviceOptions: [], // 仪器信息选项列表
      merchantData: {}, // 商家数据字典
      form: {
        reason: '',
        address: '',
        contact: '',
        phone: '',
        expressCompany: '',
        trackingNumber: '',
        targetMerchant: '', // 转寄商家
        deviceInfo: '', // 仪器信息
        deviceModel: '', // 仪器型号
        referencePrice: '', // 参考价格
        actualPrice: '', // 实际价格
        returnForwardId: '', // 转寄记录ID
        sampleCount: '' // 转寄样品数
      },
      logisticsOptions: [], // 物流公司列表
      rules: {
        address: [
          { required: true, message: '请输入转寄地址', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        sampleCount: [
          { required: true, message: '请输入转寄样品数', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正确的样品数量', trigger: 'blur' }
        ],
        targetMerchant: [
          { required: true, message: '请选择转寄商家', trigger: 'change' }
        ],
        deviceInfo: [
          { required: true, message: '请输入仪器信息', trigger: 'blur' }
        ],
        actualPrice: [
          { required: true, message: '请输入实际价格', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的价格格式', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getOrderDetail()
    this.getMerchantList()
    this.fetchLogisticsList()
  },
  methods: {
    async fetchLogisticsList() {
      try {
        const res = await adminApi.getLogisticsList()
        if (res && Array.isArray(res)) {
          // 转换为select需要的格式
          this.logisticsOptions = res.map(item => ({
            value: item.trackCode,
            label: item.trackName
          }))
        } else {
          this.$message.warning('获取物流公司列表失败')
        }
      } catch (error) {
        console.error('获取物流公司列表错误:', error)
        this.$message.error('获取物流公司列表失败: ' + (error.message || '未知错误'))
      }
    },
    async getMerchantList() {
      try {
        const res = await adminApi.getMerchantList()
        if (res && Array.isArray(res)) {
          // 格式化数据为下拉框需要的格式
          this.merchantOptions = res.map(item => ({
            value: item.id.toString(),
            label: `${item.companyName}`
          }))
          
          // 构建商家数据查找表，用于回填联系信息和仪器列表
          this.merchantData = {}
          res.forEach(item => {
            // 获取仪器列表
            const equipmentList = item.deviceInfoList || []
            
            // 处理仪器选项
            const equipment = equipmentList.map(device => ({
              value: device.id.toString(),
              label: device.deviceName,
              model: device.deviceModel || '', // 添加仪器型号
              referencePrice: device.price || '0.00',
              actualPrice: device.price || '0.00'
            }))
            
            // 存储商家信息
            this.merchantData[item.id] = {
              contact: item.contactPerson || '',
              phone: item.phone || item.contactPhone || '', // 优先使用 phone 字段，如果没有则使用 contactPhone
              address: item.address || '',
              equipment: equipment
            }
          })
        } else {
          this.merchantOptions = []
          this.$message.warning('获取商家列表失败')
        }
      } catch (error) {
        console.error('获取商家列表失败:', error)
        this.$message.error('获取商家列表失败')
        this.merchantOptions = []
      }
    },
    handleMerchantChange(value) {
      if (this.merchantData[value]) {
        const merchantInfo = this.merchantData[value]
        // 自动填充联系信息
        this.form.contact = merchantInfo.contact
        this.form.phone = merchantInfo.phone
        this.form.address = merchantInfo.address
        
        // 更新仪器选项
        this.deviceOptions = merchantInfo.equipment || []
        this.form.deviceInfo = '' // 清空已选仪器
        // 清空价格
        this.form.referencePrice = ''
        this.form.actualPrice = ''
      } else {
        this.deviceOptions = []
      }
    },
    handleDeviceChange(value) {
      // 根据选择的仪器回填价格和型号
      if (this.form.targetMerchant && value) {
        const merchantEquipment = this.merchantData[this.form.targetMerchant]?.equipment || []
        const selectedEquipment = merchantEquipment.find(item => item.value === value)
        
        if (selectedEquipment) {
          // 回填参考价格和实际价格
          this.form.referencePrice = selectedEquipment.referencePrice
          this.form.actualPrice = selectedEquipment.actualPrice
          // 回填仪器型号
          this.form.deviceModel = selectedEquipment.model || ''
        }
      }
    },
    async getOrderDetail() {
      try {
        const res = await adminApi.getOrderById(this.orderId)
        if (res) {
          this.orderInfo = {
            projectName: res.projectName || '',
            orderSn: res.orderSn || '',
            merchantName: res.merchantName || '',
            contact: res.customerPerson || '',
            phone: res.customerPhone || '',
            address: res.customerAddress || '',
            testCount: res.testCount || 0,
            deviceName: res.deviceName || '',
            orderAmount: res.actualPrice || ''
          }
          
          // 设置参考价格和样品数量
          this.form.referencePrice = res.referencePrice || ''
          
          
          // 获取转寄说明和转寄记录ID
          if (res.orderReturnForwardList && res.orderReturnForwardList.length > 0) {
            const returnForwardInfo = res.orderReturnForwardList[0];
            this.form.reason = returnForwardInfo.reason || '';
            this.form.returnForwardId = returnForwardInfo.id || '';
            this.form.sampleCount = returnForwardInfo.returnForwardCount || '';
          }
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败')
      }
    },
    handleCancel() {
      this.$router.back()
    },
    handleSubmit() {
      this.$refs.forwardForm.validate(async valid => {
        if (valid) {
          try {
            // 获取当前时间作为转寄时间
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            const currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            // 获取快递公司名称
            const expressCompanyName = this.logisticsOptions.find(
              option => option.value === this.form.expressCompany
            )?.label || this.form.expressCompany;

            // 构造提交数据
            const submitData = {
              id: this.form.returnForwardId, // 添加转寄记录ID
              orderSn: this.orderInfo.orderSn,
              // 转寄为2
              isReturnForward: 2,
              reason: this.form.reason,
              remark: '',
              
              // 目标商家信息
              targetMerchantId: this.form.targetMerchant,
              targetMerchantName: this.merchantOptions.find(item => item.value === this.form.targetMerchant)?.label || '',
              targetMerchantPerson: this.form.contact,
              targetMerchantPhone: this.form.phone,
              targetMerchantAddress: this.form.address,
              
              // 仪器信息和价格
              targetDeviceId: this.form.deviceInfo,
              targetDeviceName: this.deviceOptions.find(item => item.value === this.form.deviceInfo)?.label || '',
              targetReferencePrice: this.form.referencePrice,
              targetActualPrice: this.form.actualPrice,
              
              // 样品数量
              sampleCount: this.form.sampleCount,
              
              // 物流信息
              trackSn: this.form.trackingNumber,
              trackName: expressCompanyName, // 提交物流公司名称而非代码
              returnForwardTime: currentTime
            }
            
            const res = await adminApi.forwardSample(submitData)
            if (res) {
              this.$message.success('转寄信息提交成功')
              
              // 根据用户角色决定跳转路径
              const userRole = localStorage.getItem('userRole')
              if (userRole === 'merchant') {
                // 商家端跳转到商家的订单页面
                this.$router.push('/merchant/orders/return')
              } else {
                // 管理员端跳转到管理员的订单页面
                this.$router.push('/admin/orders/return')
              }
            } else {
              this.$message.error(res.msg || '提交失败')
            }
          } catch (error) {
            console.error('提交转寄信息失败:', error)
            this.$message.error('提交失败')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.not-shipped-orders {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.shipping-form {
  width: 100%;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.form-card .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-input,
.el-select,
.el-date-picker,
.el-radio-group,
.el-upload,
.el-textarea {
  width: 100%;
}

/* 两列布局 */
.form-row {
  display: flex;
  justify-content: space-between;
  margin: 0 -10px;
}

.form-col {
  flex: 1;
  padding: 0 10px;
}

/* 表单操作按钮 */
.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}

/* 物流信息样式 */
.logistics-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #ecf5ff;
  border-radius: 4px;
}

.logistics-company {
  font-weight: bold;
  color: #409eff;
  margin-bottom: 10px;
}

.tracking-number {
  color: #606266;
  font-family: monospace;
}

/* 备注文本域样式 */
.remark-textarea textarea {
  min-height: 120px;
  resize: vertical;
}

/* 订单基本信息样式 */
.order-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-label {
  width: 120px;
  color: #606266;
  font-weight: bold;
}

.info-value {
  flex: 1;
  color: #303133;
}

.el-textarea {
  width: 100%;
}

.el-textarea >>> .el-textarea__inner {
  font-family: inherit;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
  padding: 8px 12px;
}

/* 禁用状态的文本域样式 */
.el-textarea.is-disabled >>> .el-textarea__inner {
  color: #606266;
  background-color: #f5f7fa;
}

/* 占位符文字样式 */
.el-textarea >>> .el-textarea__inner::placeholder {
  color: #c0c4cc;
  font-size: 14px;
}
</style> 